@if (!chartReady()) {
  <div class="w-full relative">
  <div class="bg-white rounded rounded-xl h-[400px]">
    <chl-loader
      class="!absolute !top-1/2 !left-1/2 -translate-x-1/2 -translate-y-1/2"
    />
  </div>
</div>
} @else {
  <co-chart-card
  [chartHeader]="chartHeader()"
  [cssClass]="cssClass()"
  [filterOptions]="filterOptions()"
  [selectedFilters]="selectedFilters"
  (onFilterChange)="onDropdownChange()"
  [testResult]="testResult()"
 
>
  <div chart-content>
    @if (data().length) {
    <apx-chart
      [series]="chartOptions().series"
      [chart]="chartOptions().chart"
      [xaxis]="chartOptions().xaxis"
      [yaxis]="chartOptions().yaxis"
      [plotOptions]="chartOptions().plotOptions"
      [legend]="chartOptions().legend"
      [stroke]="chartOptions().stroke"
      [colors]="chartOptions().colors"
      [tooltip]="chartOptions().tooltip"
    ></apx-chart>
    }   @else
    {
    <div class="flex items-center justify-center">
      <span class="text-black-500 text-lg font-medium">{{"REPORTS.NO_DATA_FOUND" | translate}}</span>
    </div>
    } @if(ChartStats) {

    <div class="mt-4 text-sm text-gray-700" [innerHTML]="ChartStats"></div>

    }
  </div>
</co-chart-card>
}